import React, { Component } from 'react';
import PropTypes from 'prop-types';


import DateTime from "components/Display/ViewDateTime";
import ClaimState from "../Display/ClaimState";
import ID from "../Display/ID";
import Amount from "components/Display/Amount";

const ClaimOverViewTable = ({ list, onErrorClick, onClaimIDClick,onClaimNumberClick }) => {
  if (!list){
    return (
      <div/>
    );
  }

  let numberOfRecords = list.length;

  return (
      <div className="calc-setting-table ">
        <table className="table">
          <colgroup>
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
          </colgroup>
          <thead>
          <tr>
            <th colSpan="15" className="text-left calc-setting-table-header">{numberOfRecords} skráðar færslur</th>
          </tr>
          <tr>
            <th className="text-left">ClaimID</th>
            <th className="text-left">DebtorRegno</th>
            <th className="text-left">ClaimOwnerRegno</th>
            <th className="text-left">PublicOfficeRegno</th>
            <th className="text-left">RepresentativeRegno</th>
            <th className="text-left">ClaimNumber</th>
            <th className="text-left">ClaimDate</th>
            <th className="text-left">ClaimType</th>
            <th className="text-left">StatusID</th>
            <th className="text-left">ActivateDate</th>
            <th className="text-left">DeactivateDate</th>
            <th className="text-left">DeactivateReason</th>
            <th className="text-left">RegisterDate</th>
            <th className="text-left">Capital</th>
            <th className="text-left">Currency</th>
          </tr>
          </thead>
          <tbody>
          {list.map(function(item,i){
            return(
              <tr key={i}>

                {item.claimID && <td className="text-left"><a onClick={(e)=>onClaimIDClick(e,item)}><ID data={item.claimID}/></a> </td>}
                {!item.claimID && <td className="text-left"> </td>}
                <td className="text-left">{item.debtorRegno} </td>
                <td className="text-left">{item.claimOwnerRegno} </td>
                <td className="text-left">{item.publicOfficeRegno} </td>
                <td className="text-left">{item.representativeRegno} </td>
                <td className="text-left"><a onClick={(e)=>onClaimNumberClick(e,item)}>{item.claimNumber}</a> </td>
                <td className="text-left"><DateTime data={item.claimDate} skipTime/> </td>
                <td className="text-left">{item.claimType} </td>
                { item.statusID === 4 && <td className="text-left"><a onClick={(e)=>onErrorClick(e,item)}><ClaimState data={item.statusID}/></a> </td>}
                { item.statusID !== 4 && <td className="text-left"><ClaimState data={item.statusID}/></td>}
                <td className="text-left"><DateTime data={item.activateDate}/> </td>
                <td className="text-left"><DateTime data={item.deactivateDate}/> </td>
                <td className="text-left"><ID data={item.deactivateReason}/> </td>
                <td className="text-left"><DateTime data={item.registerDate}/> </td>
                <td className="text-left"><Amount data={item.capital}/> </td>
                <td className="text-left">{item.currency} </td>
              </tr>);
          })}
          </tbody>
        </table>
      </div>
  );
};

ClaimOverViewTable.propTypes = {
  list: PropTypes.array,
  onErrorClick : PropTypes.func,
  onClaimIDClick : PropTypes.func,
  onClaimNumberClick : PropTypes.func
};

export default ClaimOverViewTable;




// WEBPACK FOOTER //
// ./src/pages/ClaimTracker/Overview/ClaimOverViewTable.js